import { populateStateProvince } from 'ui/forms';
import { initBlockEnterKeyForDisabledButton, initRegularFormSubmissionActivity } from 'utilities/dom';
import { getDefaultCountryCode } from 'utilities/localization';

$(() => {

	const submitFormBtn = document.getElementById('sendCatlogSubmitBtn');
	const defaultCountryCode = getDefaultCountryCode();
	const { countries } = window.lp.globals;
	const countryData = document.querySelector('.country');
	if (countries && countryData) {

		window.lp.utils.regions.setOptionsForCountrySelect(defaultCountryCode, countries, countryData);

	}
	initBlockEnterKeyForDisabledButton(submitFormBtn);
	initRegularFormSubmissionActivity(submitFormBtn);
	// Initialize Validation
	window.initFormValidation(true, '.lightingCatalogForm');

	function getCustomerShippingState ($stateDropdown) {

		return $stateDropdown.data('primaryState');

	}

	const $stateDropdown = $('#state');
	const $country = $('#ddlCountry');

	populateStateProvince($stateDropdown, $country, getCustomerShippingState($stateDropdown));

	if (!getCustomerShippingState($stateDropdown)) {

		$stateDropdown.prepend($('<option />').val('').text(''));

	}

	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

	}
	const showAddressBtn = document.querySelector('.showAnotherAddressField');
	showAddressBtn.addEventListener('click', (event) => {

		event.preventDefault();
		const hideAddress = document.querySelector('.showAnotherAddressFieldContainer');
		if (hideAddress) {

			hideAddress.classList.add('hidden');

		}
		const showAddressField = document.querySelector('.anotherAddressField');
		if (showAddressField) {

			showAddressField.classList.remove('hidden');

		}
		const addressField = document.querySelector('.address2');
		if (addressField) {

			addressField.focus();

		}
		showAddressBtn.setAttribute('aria-expanded', true);

	});

	const showCountryBtn = document.querySelector('.jsShowCountry');
	showCountryBtn.addEventListener('click', (event) => {

		event.preventDefault();
		const showCountry = document.querySelector('.showCountry');
		if (showCountry) {

			showCountry.classList.add('hidden');

		}
		const hideCountryField = document.querySelector('.countryField');
		if (hideCountryField) {

			hideCountryField.classList.remove('hidden');

		}
		showCountryBtn.setAttribute('aria-expanded', true);

	});
	if (countryData) {

		countryData.addEventListener('change', (e) => {

			populateStateDropdown(e.target.value);

		});

	}

	function populateStateDropdown (country = defaultCountryCode, selectedState) {

		window.lp.utils.regions.setOptionsForStateProvinceSelect(country, '', $stateDropdown[0]);

	}

});
